import { render, staticRenderFns } from "./skins.vue?vue&type=template&id=0ebed4df"
import script from "./skins.vue?vue&type=script&lang=js"
export * from "./skins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports